'use strict';


var ad_table = function () {
  var self = this;

  self.init();
  self.bind();

};

ad_table.prototype.bind = function () {
  var self = this;

  // console.log('bind ad_table');

  jQuery(document).arrive('.ad_table', self.init_table);

};

ad_table.prototype.init = function () {
  var self = this;

  // console.log('init ad_table');

  self.init_table();

};

ad_table.prototype.init_table = function () {
  //var self = this;



    // jQuery('.ad_table').each(
    //   function (/*index*/) {
    //     var element = jQuery(this);

    //     if (element.hasClass('st_mounted') === false) {

    //       console.log('ad_table: ');
    //       console.log(element);

    //       element.addClass('st_mounted');

    //     }

    //   }
    // );


    jQuery(document).on(
        'click',
        '.ad_table table tr.has_link',
        function (event) {

          event.preventDefault();
          event.stopPropagation();

          // console.log('click en table_row');

          var url = jQuery(this).attr('data-href');

          // console.log('Vamos a ir a la url: ' + url);
          window.location.href = url;

        }
    );



};


jQuery( document ).ready(function() {

  window.ad_table = new ad_table();

});



